import React from 'react'
import Common from '../components/Common'
import Footer from '../components/Footer'
export default function Gallery() {
  return (
    <div>
       <Common/>
            <h1>this this Gallery page</h1>
            <Footer/>
    </div>
  )
}
